class SpaFinder {
    constructor() {
        this.locationInput = document.getElementById("spa-location-input");
        this.suggestionsList = document.getElementById("spa-suggestions");
        this.resultsContainer = document.getElementById("spa-results");
        this.wrapper = document.getElementById("spa-results-map-wrapper");
        this.mapContainer = document.getElementById("spa-map");
        this.mobileHeader = document.getElementById("spa-mobile-header");
        this.clearText = document.getElementById('spa-clear-text');
        this.input = document.getElementById('spa-location-input');

        this.map = null;
        this.markers = [];
        this.activeIndex = null;
        this.mapInitialized = false;
        this.suggestionTimeout = null;
        const config = window.spaMapData || {};  
        this.maptilerKey = config.maptilerKey || '';
        this.apiBaseUrl = config.apiBaseUrl || '';
        this.centerLat = config.centerLat || '';
        this.centerLon = config.centerLon || '';
        this.zoom = config.zoom || '';
        this.radiusKm = config.radiusKm || '25';
        this.zenotiBaseUrl = config.zenotiBaseUrl || '';
        this.mapsBaseUrl = config.mapsBaseUrl || '#';
        this.rawBookingBaseUrl = config.bookingBaseUrl || '';
        this.bookingLabel = config.bookingLabel || 'Book Now';
        this.coopGestures = config.enableCooperativeGestures || true;
        this.init();
    }

    init() {
        this.fetchSpas(this.centerLat, this.centerLon,this.radiusKm);
    }

    

    initMap(spas) {
        if (this.mapInitialized) return;

        this.wrapper.classList.remove("hidden");

        setTimeout(() => {
            this.map = new maptilersdk.Map({
                container: 'spa-map',
                style: `https://api.maptiler.com/maps/streets/style.json?key=${this.maptilerKey}`,
                center: [this.centerLon, this.centerLat],
                zoom: this.zoom,
                bearing: 0,
                dragRotate: false,
                geolocateControl: true,
                navigationControl: false,
                cooperativeGestures: this.coopGestures
            });

            this.map.addControl(
                new maptilersdk.NavigationControl({
                    showCompass: false,
                    showZoom: true
                }),
                'top-right'
            );
            this.mapInitialized = true;
            // Fit map to bounds

            if (spas.length > 0) {
              const bounds = new maptilersdk.LngLatBounds();
              spas.forEach(spa => {
                if (spa.coordinates) {
                  bounds.extend([spa.coordinates.longitude, spa.coordinates.latitude]);
                }
              });
              // Only fit bounds if valid bounds were created
              if (bounds.getNorthEast() && bounds.getSouthWest()) {
                map.fitBounds(bounds, {
                  padding: 50,
                  duration: 600,
                });
              }

            }
        }, 100);
    }

    renderMap(spas) {
        if (!this.map || !this.mapInitialized) return;

        ['clusters', 'cluster-count', 'unclustered-point', 'selected-marker'].forEach(layer => {
            if (this.map.getLayer(layer)) {
                try { this.map.removeLayer(layer); } catch (e) { }
            }
        });
        ['spas', 'selected-marker'].forEach(src => {
            if (this.map.getSource(src)) {
                try { this.map.removeSource(src); } catch (e) { }
            }
        });

        const geojson = {
            type: "FeatureCollection",
            features: spas
                .filter(spa => spa.coordinates)
                .map((spa, index) => ({
                    type: "Feature",
                    properties: {
                        spaId: spa.spa_id,
                        index: index,
                        displayName: spa.displayName,
                        distance: spa.distanceFromSearch?.value || 0,
                        distanceUnit: spa.distanceFromSearch?.unit || 'km',
                        zenotiGuid: spa.zenotiGuid || window.spaMapData?.spaZenotiGuid,
                        handle: spa.handle,
                        openingHoursStatus: JSON.stringify(spa.openingHoursStatus || {}),
                        fullAddress: spa.address?.fullAddress || '',
                        address: spa.address ?? null,
                        email: spa.emailAddress || '',
                        phone: spa.phoneNumber || '',
                        locationFeatures: JSON.stringify(spa.locationFeatures || [])
                    },
                    geometry: {
                        type: "Point",
                        coordinates: [spa.coordinates.longitude, spa.coordinates.latitude]
                    }
                }))
        };

        this.map.addSource('spas', {
            type: 'geojson',
            data: geojson,
            cluster: true,
            clusterMaxZoom: this.zoom,
            clusterRadius: this.radiusKm
        });

        this.addClusterLayers();
        this.addUnclusteredLayers();
    }

    addClusterLayers() {
        const clusterSvg = `
 <svg width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
<defs>
  <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
    <feDropShadow dx="0" dy="0" stdDeviation="4" flood-color="rgba(0,0,0,1)" />
  </filter>
</defs>
<circle cx="27" cy="27" r="16" fill="#F2F0EC" stroke="#2B6229" stroke-width="5" filter="url(#softShadow)"/>
<circle cx="27" cy="27" r="13.5" fill="#F2F0EC" stroke="#385645" stroke-width="3"  />
</svg>`;

        const clusterUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(clusterSvg);
        const clusterImg = new Image();
        clusterImg.onload = () => {
            if (!this.map.hasImage('custom-cluster')) this.map.addImage('custom-cluster', clusterImg);
        };
        clusterImg.src = clusterUrl;

        if (!this.map.getLayer('clusters')) {
            this.map.addLayer({
                id: 'clusters',
                type: 'symbol',
                source: 'spas',
                filter: ['has', 'point_count'],
                layout: {
                    'icon-image': 'custom-cluster',
                    'icon-size': 1,
                    'icon-allow-overlap': true
                }
            });
        }

        if (!this.map.getLayer('cluster-count')) {
            this.map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'spas',
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                    'text-size': 14,
                    'text-offset': [0, 0]
                },
                paint: {
                    'text-color': '#385645'
                }
            });
        }

        if (!this.map.__spaHandlers) this.map.__spaHandlers = {};
        if (!this.map.__spaHandlers.clusters) {
            this.map.on('click', 'clusters', (e) => {
                const features = this.map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
                if (!features.length) return;
                const clusterId = features[0].properties.cluster_id;
                const source = this.map.getSource('spas');
                source.getClusterExpansionZoom(clusterId, (err, zoom) => {
                    if (err) return;
                    this.map.easeTo({ center: features[0].geometry.coordinates, zoom });
                });
            });
            this.map.on('mouseenter', 'clusters', () => (this.map.getCanvas().style.cursor = 'pointer'));
            this.map.on('mouseleave', 'clusters', () => (this.map.getCanvas().style.cursor = ''));
            this.map.__spaHandlers.clusters = true;
        }
    }

    addUnclusteredLayers() {
        const greenSvgMarker = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="57" viewBox="0 0 40 57" fill="none">
  <path d="M39.6455 19.8228C39.6455 30.7706 23.8545 56.4444 19.8228 56.4444C17.1349 56.4444 0 30.7706 0 19.8228C0 8.87495 8.87495 0 19.8228 0C30.7706 0 39.6455 8.87495 39.6455 19.8228Z" fill="#385645"/>
  <g clip-path="url(#clip0_9400_5449)">
  <mask id="mask0_9400_5449" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="5" y="6" width="30" height="31">
  <rect x="5.37598" y="6.71973" width="29.5661" height="29.5661" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_9400_5449)">
  <path d="M20.1589 30.7586C22.569 28.6011 24.4132 26.5317 25.6918 24.5504C26.9703 22.569 27.6096 20.8336 27.6096 19.3443C27.6096 17.0985 26.8961 15.2522 25.4691 13.8055C24.0421 12.3588 22.2721 11.6355 20.1589 11.6355C18.0457 11.6355 16.2757 12.3588 14.8487 13.8055C13.4217 15.2522 12.7082 17.0985 12.7082 19.3443C12.7082 20.8336 13.3475 22.569 14.626 24.5504C15.9046 26.5317 17.7489 28.6011 20.1589 30.7586ZM20.1589 32.5163C19.9189 32.5163 19.6789 32.4749 19.4388 32.3922C19.1986 32.3092 18.9814 32.1809 18.7872 32.0072C17.6817 30.9884 16.6472 29.9392 15.6836 28.8596C14.7203 27.7803 13.8829 26.7012 13.1714 25.6224C12.4598 24.5437 11.8967 23.4745 11.4822 22.4148C11.0676 21.355 10.8604 20.3314 10.8604 19.3443C10.8604 16.5014 11.7799 14.1998 13.6189 12.4396C15.4582 10.6794 17.6382 9.79932 20.1589 9.79932C22.6796 9.79932 24.8596 10.6794 26.6989 12.4396C28.5379 14.1998 29.4575 16.5014 29.4575 19.3443C29.4575 20.3314 29.2502 21.3529 28.8356 22.4087C28.4211 23.4646 27.8601 24.5339 27.1525 25.6166C26.4448 26.6992 25.6092 27.7783 24.6459 28.8538C23.6825 29.9294 22.648 30.9766 21.5424 31.9952C21.351 32.1689 21.1335 32.2991 20.8897 32.386C20.6462 32.4728 20.4026 32.5163 20.1589 32.5163ZM20.1611 21.3366C20.7739 21.3366 21.2979 21.1183 21.733 20.6818C22.1683 20.2453 22.3859 19.7206 22.3859 19.1077C22.3859 18.4948 22.1677 17.9708 21.7311 17.5355C21.2946 17.1004 20.7698 16.8829 20.1567 16.8829C19.5439 16.8829 19.0199 17.1011 18.5848 17.5376C18.1495 17.9741 17.9319 18.4989 17.9319 19.112C17.9319 19.7249 18.1502 20.2489 18.5867 20.684C19.0232 21.119 19.548 21.3366 20.1611 21.3366Z" fill="white"/>
  </g>
  </g>
  <defs>
  <clipPath id="clip0_9400_5449">
  <rect width="29.5661" height="29.5661" fill="white" transform="translate(5.37598 6.71973)"/>
  </clipPath>
  </defs>
  </svg>`;

        const greenUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(greenSvgMarker);
        const greenImg = new Image();
        greenImg.onload = () => { if (!this.map.hasImage('green-marker')) this.map.addImage('green-marker', greenImg); };
        greenImg.src = greenUrl;

        if (!this.map.getLayer('unclustered-point')) {
            this.map.addLayer({
                id: 'unclustered-point',
                type: 'symbol',
                source: 'spas',
                filter: ['!', ['has', 'point_count']],
                layout: {
                    'icon-image': 'green-marker',
                    'icon-size': 0.8,
                    'icon-anchor': 'bottom',
                    'icon-allow-overlap': true
                }
            });
        }

        if (!this.map.__spaHandlers?.unclustered) {
            this.map.on('click', 'unclustered-point', (e) => {
                this.handleMarkerClick(e);
            });

            this.map.on('mouseenter', 'unclustered-point', () => (this.map.getCanvas().style.cursor = 'pointer'));
            this.map.on('mouseleave', 'unclustered-point', () => (this.map.getCanvas().style.cursor = ''));
            this.map.__spaHandlers.unclustered = true;
        }
    }

    handleMarkerClick(e) {
        const feature = e.features?.[0];
        if (!feature) return;
        const coords = feature.geometry.coordinates.slice();
        document.querySelectorAll('.maptilersdk-popup').forEach(p => p.remove());

        if (this.map.getLayer('selected-marker')) this.map.removeLayer('selected-marker');
        if (this.map.getSource('selected-marker')) this.map.removeSource('selected-marker');

        this.map.addSource('selected-marker', { type: 'geojson', data: { type: 'FeatureCollection', features: [feature] } });
        this.map.addLayer({
            id: 'selected-marker',
            type: 'symbol',
            source: 'selected-marker',
            layout: {
                'icon-image': 'green-marker',
                'icon-size': 0.8,
                'icon-anchor': 'bottom',
                'icon-allow-overlap': true
            }
        });

        const layers = this.map.getStyle().layers;
        if (layers && layers.length) this.map.moveLayer('selected-marker', layers[layers.length - 1].id);

        this.map.easeTo({ center: coords, offset: [0, 100], duration: 600 });

        const popupHTML = this.createPopupContentFromFeature(feature.properties, feature.properties.index);
        new maptilersdk.Popup({ offset: [0, -60], closeButton: false, focusAfterOpen: false, maxWidth: '400px', anchor: 'bottom' })
            .setLngLat(coords)
            .setHTML(popupHTML)
            .addTo(this.map);

        this.attachPopupEventListeners(feature.properties.index, feature.properties);
    }

    formatAddress(fullAddress) {
        const address = fullAddress;
        let formattedAddress = '';
        if (address) {
        let parsedAddress;
        try {
            // If it's a string, parse it; if it's already an object, just use it
            parsedAddress = typeof address === 'string' ? JSON.parse(address) : address;
        } catch (e) {
            formattedAddress = address;
        }

        if (parsedAddress) {
            const { line1, line2, city, state, postCode } = parsedAddress;
            formattedAddress = '';

            if (line1) formattedAddress += line1;
            if (line2) formattedAddress += (formattedAddress ? ', ' : '') + line2;
            if (city) formattedAddress += (formattedAddress ? ' ' : '') + city;
            if (state) formattedAddress += (formattedAddress ? ', ' : '') + state;
            if (postCode) formattedAddress += (formattedAddress ? ', ' : '') + postCode;
        }
        }

        return formattedAddress;
    }

    createPopupContentFromFeature(featureProps, index) {
        const oh = featureProps.openingHoursStatus ? JSON.parse(featureProps.openingHoursStatus) : {};

        let formattedAddress = this.formatAddress(featureProps.address);


        const directionsUrl = featureProps.fullAddress
            ? `${this.mapsBaseUrl}${encodeURIComponent(featureProps.fullAddress)}`
            : '#';

        const statusText = this.renderPopupCurrentStatus(oh);
        const statusClass = oh.currentStatus?.toLowerCase().includes("open")
            ? "open"
            : oh.currentStatus?.toLowerCase().includes("closed")
                ? "closed"
                : "unavailable";

        const phoneHtml = featureProps.phone
            ? `<div class="spa-info-item spa_phone_number">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 20 21" fill="none">
            <path d="M18.3333 15.03V17.53C18.3343 17.7622 18.2867 17.9919 18.1937 18.2045C18.1008 18.4172 17.9644 18.6081 17.7934 18.765C17.6224 18.9219 17.4205 19.0413 17.2006 19.1157C16.9808 19.19 16.7478 19.2177 16.5167 19.1968C13.9523 18.9181 11.4892 18.0419 9.32498 16.6384C7.31151 15.359 5.60443 13.6519 4.32499 11.6384C2.91663 9.46443 2.04019 6.98926 1.76665 4.41343C1.74583 4.18298 1.77321 3.95073 1.84707 3.73145C1.92092 3.51217 2.03963 3.31067 2.19562 3.13978C2.35162 2.96889 2.54149 2.83235 2.75314 2.73886C2.9648 2.64537 3.1936 2.59698 3.42499 2.59676H5.92499C6.32941 2.59278 6.72148 2.73599 7.02812 2.9997C7.33476 3.26342 7.53505 3.62963 7.59165 4.03009C7.69717 4.83015 7.89286 5.6157 8.17499 6.37176C8.2871 6.67003 8.31137 6.99419 8.24491 7.30583C8.17844 7.61747 8.02404 7.90352 7.79998 8.13009L6.74165 9.18843C7.92795 11.2747 9.65536 13.0021 11.7417 14.1884L12.8 13.1301C13.0266 12.906 13.3126 12.7516 13.6243 12.6852C13.9359 12.6187 14.26 12.643 14.5583 12.7551C15.3144 13.0372 16.0999 13.2329 16.9 13.3384C17.3048 13.3955 17.6745 13.5994 17.9388 13.9113C17.203 14.2232 18.3435 14.6214 18.3333 15.03Z" stroke="#4E4E4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <a href="tel:${featureProps.phone}">${featureProps.phone}</a>
        </div>`
            : '';

        return `
      <div class="spa-popup-content">
        <span id="popup-close-${index}" class="popup-close-btn">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--medium" fill="none" viewBox="0 0 24 24">
            <path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
  
        <div class="popup-header">
          <h3 class="popup-spa-title">${featureProps.displayName || 'Unknown Spa'}</h3>
        </div>
  
        <div class="block md:flex justify-between gap-4">
          <div class="spa-info-item spa-address">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 20 21" fill="none">
              <g clip-path="url(#clip0_4903_53)">
                <path d="M17.5 9.26367C17.5 15.097 10 20.097 10 20.097C10 20.097 2.5 15.097 2.5 9.26367C2.5 7.27455 3.29018 5.36689 4.6967 3.96037C6.10322 2.55385 8.01088 1.76367 10 1.76367C11.9891 1.76367 13.8968 2.55385 15.3033 3.96037C16.7098 5.36689 17.5 7.27455 17.5 9.26367Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 11.7637C11.3807 11.7637 12.5 10.6444 12.5 9.26367C12.5 7.88296 11.3807 6.76367 10 6.76367C8.61929 6.76367 7.5 7.88296 7.5 9.26367C7.5 10.6444 8.61929 11.7637 10 11.7637Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
            ${formattedAddress}
          </div>
  
          <div class="spa-info-item spa_direction">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <path d="M12 9.59684V13.5968C12 13.9505 11.8595 14.2896 11.6095 14.5397C11.3594 14.7897 11.0203 14.9302 10.6667 14.9302H3.33333C2.97971 14.9302 2.64057 14.7897 2.39052 14.5397C2.14048 14.2896 2 13.9505 2 13.5968V6.26351C2 5.90989 2.14048 5.57075 2.39052 5.3207C2.64057 5.07065 2.97971 4.93018 3.33333 4.93018H7.33333" stroke="#49A750" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 2.93018H14V6.93018" stroke="#49A750" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.66663 10.2635L14 2.93018" stroke="#49A750" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <a href="${directionsUrl}" target="_blank">Get Directions</a>
          </div>
        </div>
  
        ${phoneHtml}
  
        <div class="popup-opening-status ${statusClass}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M9.99996 19.2633C14.6023 19.2633 18.3333 15.5324 18.3333 10.93C18.3333 6.32764 14.6023 2.59668 9.99996 2.59668C5.39759 2.59668 1.66663 6.32764 1.66663 10.93C1.66663 15.5324 5.39759 19.2633 9.99996 19.2633Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 5.93018V10.9302L13.3333 12.5968" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div>${statusText}</div>
        </div>
  
        <div class="spa-info-footer">
          <button id="popup-info-${index}" class="btn btn--secondary">More Info</button>
          <button id="popup-booking-${index}" class="btn btn--primary booking-btn" data-zenoti-guid="${featureProps.zenotiGuid}">
            ${this.bookingLabel}
          </button>
        </div>
      </div>
    `;
    }

    renderPopupCurrentStatus(spa) {
        if (!spa || !spa.currentStatus) return 'Status unavailable';
        let statusText = '';
        const nextStatus = spa.nextStatus.charAt(0).toLowerCase() + spa.nextStatus.slice(1);
        if (spa.currentStatus && spa.currentStatus.toLowerCase().includes("open")) {
        if (spa.nextStatus && spa.nextStatus.toLowerCase().includes("closes")) {
            statusText = `<span>${spa.currentStatus}, </span> ${nextStatus}`;
        }
        } else if (spa.currentStatus && spa.currentStatus.toLowerCase().includes("closed")) {
        if (spa.nextStatus && spa.nextStatus.toLowerCase().includes('opens')) {
            statusText = `<span>${spa.currentStatus}, </span> ${nextStatus}`;
        } else {
            statusText = `<span>${spa.currentStatus} </span>`;
        }
        } else {
        statusText = `<span>Status unavailable </span>`;
        }

        return statusText;
    }

    attachPopupEventListeners(index, featureProps) {
        setTimeout(() => {
            const closeBtn = document.getElementById(`popup-close-${index}`);

            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();

                    const popups = document.querySelectorAll('.maptilersdk-popup, .maplibregl-popup, .mapboxgl-popup');

                    popups.forEach(p => {
                        p.remove();
                    });

                    if (this.map && this.map.getLayer && this.map.getLayer('selected-marker')) {
                        this.map.removeLayer('selected-marker');
                    }
                    if (this.map && this.map.getSource && this.map.getSource('selected-marker')) {
                        this.map.removeSource('selected-marker');
                    }
                });
            }

            const infoBtn = document.getElementById(`popup-info-${index}`);
            if (infoBtn) {
                infoBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (featureProps.handle) {
                        window.location.href = `/pages/find-s-spa/${featureProps.handle}`;
                    }
                });
            }

            const bookingBtn = document.getElementById(`popup-booking-${index}`);
            if (bookingBtn) {
                bookingBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const zenotiGuid = bookingBtn.getAttribute('data-zenoti-guid');
                    const bookingUrl = this.createBookingUrl(zenotiGuid);
                    window.open(bookingUrl, '_blank');
                });
            }
        }, 200);
    }

    selectSpaByIndex(index) {
        const canvas = document.querySelector('.maplibregl-canvas');
        if (canvas) {
            canvas.click();
        }

        const results = document.querySelectorAll('.endota-spa-block');
        if (!results[index]) return;

        results.forEach((el, i) => el.classList.toggle('is-selected', i === index));
        results[index].scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (!this.map || !this.mapInitialized) return;

        const source = this.map.getSource('spas');
        if (!source || !source._data) return;

        const feature = source._data.features[index];
        if (!feature) return;

        const coords = feature.geometry.coordinates;

        document.querySelectorAll('.maptilersdk-popup').forEach(p => p.remove());

        if (this.map.getLayer('selected-marker')) this.map.removeLayer('selected-marker');
        if (this.map.getSource('selected-marker')) this.map.removeSource('selected-marker');

        this.map.addSource('selected-marker', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [feature]
            }
        });

        this.map.addLayer({
            id: 'selected-marker',
            type: 'symbol',
            source: 'selected-marker',
            layout: {
                'icon-image': 'green-marker',
                'icon-size': .8,
                'icon-anchor': 'bottom',
                'icon-allow-overlap': true
            }
        });

        const layers = this.map.getStyle().layers;
        if (layers && layers.length > 0) {
            const lastLayerId = layers[layers.length - 1].id;
            this.map.moveLayer('selected-marker', lastLayerId);
        }

        this.map.easeTo({
            center: coords,
            zoom: 13,
            offset: [0, 100],
            essential: true,
            speed: 500,
            curve: 8
        });

        setTimeout(() => {
            const popup = new maptilersdk.Popup({
                offset: [0, -40],
                closeButton: false,
                maxWidth: '320px',
                anchor: 'bottom'
            })
                .setLngLat(coords)
                .setHTML(this.createPopupContentFromFeature(feature.properties, index))
                .addTo(this.map);

            this.attachPopupEventListeners(index, feature.properties);
        }, 600);
    }

    createBookingUrl(zenotiGuid) {
        let bookingUrl = window.spaMapData.bookingBaseUrl;

        if (zenotiGuid) {
            bookingUrl = bookingUrl.replace("[spa_id]", zenotiGuid);
        }

        if (!bookingUrl.startsWith("http")) {
            bookingUrl = window.spaMapData.zenotiBaseUrl + bookingUrl;
        }

        return bookingUrl;
    }

    fetchSpas(lat, lng, radius) {
        if(this.wrapper != null)
        {
            this.wrapper.classList.add("hidden");
            this.wrapper.classList.remove("is-hidden");
            this.wrapper.classList.remove('list-view', 'map-view');
        }


        const mapContainer = document.getElementById('map');
        const mapWrapper = document.querySelector('.map-wrapper');
        const spaMapContainer = document.querySelector('.spa-map-container');
     
        fetch(`${this.apiBaseUrl}/api/spas/nearby/opening-hours?latitude=${lat}&longitude=${lng}&distance=${radius}`)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`API Error: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                if (data.spas && data.spas.length) {
                    data.spas = data.spas.filter(spa => {
                        const status = spa.status || '';
                        const isPermanentlyClosed = status.toLowerCase().includes('permanently closed');
                        return !isPermanentlyClosed;
                    });
                }

                if (!data.spas || !data.spas.length) {
                    loadingContainer.innerHTML = `<div class="no-results">No nearest spa found.</div>`;
                    loadingContainer.style.display = 'block';
                    this.wrapper.classList.add("hidden");
                    if(this.resultsContainer)
                    {
                    this.resultsContainer.innerHTML = "";
                    if (mapContainer) mapContainer.style.display = 'none';
                    if (mapWrapper) mapWrapper.style.display = 'none';
                    if (spaMapContainer) spaMapContainer.style.display = 'none';
                    }
                 return;

                }

                this.initMap(data.spas);
                const waitForMapInit = () => {
                    if (this.mapInitialized && this.map) {
                        this.renderMap(data.spas);

                        if (data.spas.length > 0) {
                            const firstSpa = data.spas[0];
                            if (firstSpa.coordinates) {
                                this.map.flyTo({
                                    center: [firstSpa.coordinates.longitude, firstSpa.coordinates.latitude],
                                    zoom: 8
                                });
                            }
                        }
                    } else {
                        setTimeout(waitForMapInit, 2000);
                    }
                };
                waitForMapInit();
            })
            .catch(err => {
                loadingContainer.innerHTML = `<div class="no-results">something went wrong. try again.</div>`;
                loadingContainer.style.display = 'block';
                this.wrapper.classList.add("hidden");
                this.resultsContainer.innerHTML = "";
                if (mapContainer) mapContainer.style.display = 'none';
                if (mapWrapper) mapWrapper.style.display = 'none';
                if (spaMapContainer) spaMapContainer.style.display = 'none';
            });
    }

}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
    new SpaFinder();
});
